import React from 'react'
import { FormikProps, getIn } from 'formik'
import { Select as BsSelect } from 'bs-unified-ui'

interface SelectProps {
  form: FormikProps<any>
  field: {
    name: string
    value: any
  }
  onChange?: (value: any) => void
  clearable?: boolean
  multiple?: boolean
  onClear?: () => void
  disabled?: boolean
  groupByKey?: string
  forwardOptions?: (options: any) => any
  [key: string]: any
}

const Select: React.FC<SelectProps> = ({
  form,
  field,
  onChange = () => {},
  clearable = false,
  multiple = false,
  onClear = () => null,
  disabled = false,
  forwardOptions = (o) => o,
  ...props
}) => (
  <BsSelect
    {...field}
    {...props}
    multiple={multiple}
    error={
      !!getIn(form.touched, field.name) && !!getIn(form.errors, field.name)
    }
    helperText={
      getIn(form.touched, field.name) && getIn(form.errors, field.name)
    }
    onChange={(e: any, action: any) => {
      if (multiple) {
        if (
          typeof action === 'object' &&
          e.target.value &&
          !(e.target.value || []).includes('button_action')
        ) {
          form.setFieldValue(field.name, e.target.value)
        }
      } else {
        form.setFieldValue(field.name, e.target.value)
        onChange(e.target.value)
      }
    }}
    onClear={
      clearable
        ? () => {
            if (clearable) {
              form.setFieldValue(field.name, '')
              onClear()
            }
          }
        : null
    }
    clearable={clearable}
    {...(multiple
      ? {
          actionOnFocus: () => {
            form.setFieldValue(`backup_${field.name}`, field.value || [])
          },
          actionOnBlur: () => {
            form.setFieldValue(
              field.name,
              form.values[`backup_${field.name}`] || [],
            )
          },
        }
      : {})}
    disabled={disabled || !!form.values.__readOnly}
  />
)

export default Select
